export function translate_enumeration(enumeration, t) {
  var enumeration_translated = {}
  for (var enumeration_key in enumeration) {
    enumeration_translated[enumeration_key] = t(enumeration[enumeration_key]);
  }
  return enumeration_translated
}